module.exports = __webpack_public_path__ + "media/src/images/bad_request-f3af3065d496a98a98513f709f266f9f.png";